import * as React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ReactComponent as GroupsIcon } from '../assets/icons/groups.svg';
import { ReactComponent as UploadIcon } from '../assets/icons/upload.svg';
import { classNames } from 'primereact/utils';
import { Tooltip } from 'primereact/tooltip';
import { useUserRole } from '../utils/auth';

export default function Nav() {
  const userRole = useUserRole();
  const location = useLocation();


  const menuItems = [
    {
      label: 'Groups',
      icon: <GroupsIcon className="w-6 h-6" />,
      to: '/groups',
      tooltip: 'Dashboard',
    },
    ...userRole.isActuary() ? [
      {
        label: 'Upload',
        icon: <UploadIcon className="w-6 h-6" />,
        to: '/upload',
        tooltip: 'Import group or agent data',
      }
    ] : [],
  ]

  function setActiveClass({ isActive }: { isActive: boolean }) {
    const baseClass = classNames('p-3', 'flex', 'justify-center', 'transition-colors');
    if (!isActive) return baseClass;

    return [baseClass, classNames('bg-allstate-blue', 'text-white')].join(' ');
  }

  return (
    <nav className="flex flex-col gap-4 nav">
      <ul className="text-center">
        {menuItems.map((item, index) => (
            <li key={index} className="flex flex-col justify-center">
              <NavLink to={item.to} className={setActiveClass}>
                {item.icon}
              </NavLink>
              {(location.pathname !== item.to && item.tooltip) && (
                <Tooltip target={`.nav li:nth-child(${index + 1})`} content={item.tooltip} />
              )}
            </li>
        ))}
      </ul>
    </nav>
  )
}